import { gatewayApiClient } from '../../_shared/api/gatewayApiClient';
import type { GatewayPlugin } from '../types/plugin';

/**
 * #621 — 실 BE 계약: GET /plugins → GatewayPluginResponse[] (정확히 7건 고정, 정적 레지스트리).
 * create/update/delete/enable/disable 등 CRUD 엔드포인트는 BE 에 존재하지 않는다.
 */
export const pluginsApi = {
  list: async (): Promise<GatewayPlugin[]> => {
    const response = await gatewayApiClient.get<GatewayPlugin[]>('/plugins');
    return response.data;
  },
};
